import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async uploadChatFile(file) {
    const path = '/media/chat-file';

    const formData = new FormData();
    formData.append('file', file);

    const response = await axiosClient.post(path, formData);

    return response.data;
  },

  async getListChatRoom(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.CHAT}/chat-rooms${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getChatRoomDetail(payload) {
    const { id, place } = payload;
    const path = `${ENDPOINT.CHAT}/${id}?place=${place}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getChatRoomMessages(payload) {
    const { id, ...rest } = payload;
    const params = getParamsFormObject(rest);
    const path = `${ENDPOINT.CHAT}/${id}/messages${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async sendMessage(payload) {
    const { id, place, ...rest } = payload;
    const path = `${ENDPOINT.CHAT}/${id}/messages?place=${place}`;

    const response = await axiosClient.post(path, rest);

    return response.data;
  },

  async readMessage(payload) {
    const { id, place } = payload;
    const path = `${ENDPOINT.CHAT}/${id}/read?place=${place}`;

    const response = await axiosClient.post(path);

    return response.data;
  },
};
